const parseBooleanFlag = (value, fallback) => {
  if (typeof value !== "string" || value.trim() === "") {
    return fallback;
  }

  return value.trim().toLowerCase() === "true";
};

export const isBottlerAdminEnabled = parseBooleanFlag(
  process.env.REACT_APP_ENABLE_BOTTLER_ADMIN,
  process.env.REACT_APP_ENV !== "uat"
);
